import { Loader } from "@/components/common/Icons/Loader/Loader";
import { Translate } from "@/components/common/Translate/Translate";
import { useDailyQuota } from "@/modules/DailyQuota/hooks/useDailyQuota";
import { formatFileSize } from "@/utils/formatFileSize";

export const MaxFileSizeIndicatorText = () => {
    const { usageDetail, isLoading } = useDailyQuota();
    if (isLoading) {
        return (
            <div>
                <Loader height={20} />
            </div>
        );
    }
    if (!usageDetail) return null;
    return (
        <div className="text-xs text-irGray-500">
            <Translate keyName="common:max-file-size" />: {formatFileSize(usageDetail.fileSizeLimit)}
        </div>
    );
};
